'use strict';

angular.module('ringbaPortal').component('conversionDuplicationToggle', {
  bindings: {
    conversionSettings: '<',
    deDupeSetting: '<',
    readOnly: '<',
    deDupeSettingTime: '=',
    toggleValueChanged: '&',
    onTimeLimitChange: '&'
  },
  controller: ConversionDuplicationToggleController,
  controllerAs: 'vm',
  templateUrl: '/scripts/shared/components/conversion-duplication-toggle/conversion-duplication-toggle.view.html'
});

function ConversionDuplicationToggleController() {
  'ngInject';

  const vm = this;
  vm.setToggle = setToggle;
  vm.$onChanges = onChanges;

  function onChanges(changesObj) {
    if (changesObj.deDupeSetting && (changesObj.deDupeSetting.isFirstChange() || _checkPreviousDeDupeSettingEmpty(changesObj))) {
      _setDedupeDefaults();
      vm.selectedValue = _setSelectedValue(vm.conversionSettings);
    }
    if (changesObj.conversionSettings) {
      vm.selectedValue = _setSelectedValue(vm.conversionSettings);
    }
  }

  function setToggle() {
    vm.conversionSettings = parseInt(vm.conversionSettings);

    if (typeof vm.conversionSettings === 'undefined') {
      vm.conversionSettings = 0;
    }

    if (vm.selectedValue === 'no_duplicates') {
      vm.conversionSettings = 0;
    } else if (vm.selectedValue === 'allow_duplicates') {
      vm.conversionSettings = -1;
    } else if (vm.selectedValue === 'allow_after') {
      vm.conversionSettings = 1;
    } else  {
      vm.conversionSettings = 0;
    }

    vm.toggleValueChanged()(vm.conversionSettings);
  }

  function _checkPreviousDeDupeSettingEmpty(changesObj) {
    return !changesObj.deDupeSetting.previousValue && changesObj.deDupeSetting.currentValue;
  }

  function _setSelectedValue(conversionSettings) {
    if (typeof conversionSettings === 'undefined') {
      conversionSettings = 0;
    }
    else {
      conversionSettings = parseInt(conversionSettings, 10);
    }

    if (conversionSettings === 0) {
      return 'no_duplicates';
    } else if (conversionSettings === -1) {
      return 'allow_duplicates';
    } else if (conversionSettings === 1) {
      return 'allow_after';
    }

    return 'no_duplicates';
  }

  function _setDedupeDefaults() {
    let deDupeSetting = null;
    if (vm.deDupeSetting) {
      deDupeSetting = vm.deDupeSetting;
      if (deDupeSetting.secondsFromLastCall === -1) {
        vm.conversionSettings = -1;
      } else if (deDupeSetting.secondsFromLastCall === 0) {
        vm.conversionSettings = 0;
      } else if (deDupeSetting.secondsFromLastCall > 0) {
        vm.conversionSettings = 1;
      } else  {
        vm.conversionSettings = 0;
      }
    }
    vm.deDupeSettingTime = _getDaysAndHours(_.clone(deDupeSetting));
  }

  function _getDaysAndHours (deDupeSetting) {
    if (!deDupeSetting || !deDupeSetting.secondsFromLastCall || deDupeSetting.secondsFromLastCall <= 0) {
      return { days: 0, hours: 0 };
    } else {
      const daysAndHours = { days: 0, hours: 0 };
      while (deDupeSetting.secondsFromLastCall >= 24*3600) {
        daysAndHours.days += 1;
        deDupeSetting.secondsFromLastCall -= 24*3600;
      }
      while (deDupeSetting.secondsFromLastCall >= 3600) {
        daysAndHours.hours += 1;
        deDupeSetting.secondsFromLastCall -= 3600;
      }
      return daysAndHours;
    }
  }

}
